var path = '/modules/contacts/views/pages/details/documents.tpl.html';
var html = "<contact-documents ng-if=\"vm.contact\" contact=\"vm.contact\"></contact-documents>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/documents.tpl.html
// module id = 2074
// module chunks = 1